// extracted by mini-css-extract-plugin
module.exports = {"input":"add-category_input_1unnk","inputContainer":"add-category_inputContainer_363nE"};